module.exports = {
  MANUAL: 'manual',
  AUTOMATIC: 'automatic',
};
